import { render, staticRenderFns } from "./Inscriptions-doc-required-comp.vue?vue&type=template&id=5c013836&scoped=true&"
import script from "./Inscriptions-doc-required-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-doc-required-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c013836",
  null
  
)

export default component.exports